module.exports = __webpack_public_path__ + "static/media/anson.f129e8d0.png";